// src/pages/Tabingresos.jsx
import React, { useEffect, useState } from "react";
import IngresosMensualCard from "../components/dropdrop/IngresosMensualCard";
import IngresosDiarioCard from "../components/dropdrop/IngresosDiarioCard";

const parseCLP = (v) => {
  if (v === null || v === undefined) return 0;
  if (typeof v === "number") return v;
  const n = String(v).replace(/\./g, "");
  const num = Number(n);
  return Number.isFinite(num) ? num : 0;
};

const sortMonth = (a, b) => {
  const [ma, ya] = a.split("-").map(Number);
  const [mb, yb] = b.split("-").map(Number);
  return new Date(ya, ma - 1, 1) - new Date(yb, mb - 1, 1);
};

const sortDay = (a, b) => {
  const [da, ma, ya] = a.split("-").map(Number);
  const [db, mb, yb] = b.split("-").map(Number);
  return new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db);
};

export default function Tabingresos({ lastUpdate }) {
  const [monthly, setMonthly] = useState([]);
  const [daily, setDaily] = useState([]);

  const fetchData = async () => {
    const ts = lastUpdate || Date.now();
    const res = await fetch(
      `https://marketbusters.pro/Dropdrop/pedidos_ganancias_mensual.json?t=${ts}`,
      { cache: "no-store" }
    );
    const json = await res.json();

    const mensual = json.mensual || {};
    const diario = json.diario || {};

    const monthlyRows = Object.keys(mensual)
      .sort(sortMonth)
      .map((k) => ({
        mes: k,
        ganancia_total: parseCLP(mensual[k].ganancia_total),
        ganancia_flete: parseCLP(mensual[k].ganancia_flete),
        ganancia_rechazo: parseCLP(mensual[k].ganancia_rechazo),
        ganancia_comision: parseCLP(mensual[k].ganancia_comision),
      }));

    const dailyRows = Object.keys(diario)
      .sort(sortDay)
      .map((k) => ({
        fecha: k,
        ganancia_total: parseCLP(diario[k].ganancia_total),
        ganancia_flete: parseCLP(diario[k].ganancia_flete),
        ganancia_rechazo: parseCLP(diario[k].ganancia_rechazo),
        ganancia_comision: parseCLP(diario[k].ganancia_comision),
      }));

    setMonthly(monthlyRows);
    setDaily(dailyRows);
  };

  useEffect(() => { fetchData(); }, [lastUpdate]);

  return (
    <div className="space-y-6">
      <IngresosMensualCard data={monthly} />
      <IngresosDiarioCard data={daily} />
    </div>
  );
}
